<template>
    <div class="share-form-modal">
        <b-modal ref="modal" size="lg" :ok-title="'Share with '+reviewee.type.value" @ok="share" :cancel-title="'Reset'" @cancel="reset" :ok-disabled="okDisabled" :cancel-disabled="cancelDisabled">
          <FreeTextFormItem :item="reviewee.name" />
          <FreeTextFormItem :item="reviewee.email" />
          <FreeTextFormItem :item="reviewee.number" />
          <DropdownFormItem :item="reviewee.expiry" />
        </b-modal>
    </div>
</template>

<script>
    import FreeTextFormItem from "@/components/form/FreeTextFormItem.vue";
    import DropdownFormItem from "@/components/form/DropdownFormItem.vue";

    export default {
      name: "ShareFormModal",
      props: ['entryId','form'],
      components: {DropdownFormItem, FreeTextFormItem},
        data() {
            return {
              loading: false,
              shared:false,
              reviewee:{
                name:
                {
                  title: "Name",
                  value:  "",
                  required:false,
                  disabled:false,
                  type:1
                },
                email:
                {
                  title:"Email",
                  value:"",
                  required:false,
                  disabled:false,
                  type:1
                },
                number:
                {
                  title:"Phone Number",
                  value:"",
                  required:false,
                  disabled:false,
                  type:1
                },
                expiry:
                {
                  title: this.shared ? "Expires at" : "Share Time (Days)",
                  values:["1","7","14","30"],
                  value:"",
                  required:false,
                  disabled:false,
                  type:4
                },
                type:
                {
                  title:"Type",
                  value:"",
                  required:false,
                  type:1
                }
              }

            }
        },
        computed: {
          okDisabled()
          {

            if(this.loading)
            {
              return true;
            }

            if(this.shared)
            {
              return true;
            }

            return this.reviewee.name.value === "" ||
                   this.reviewee.email.value === "" ||
                   this.reviewee.number.value === "" ||
                   this.reviewee.expiry.value === "";

          },
          cancelDisabled()
          {
            if(this.loading)
            {
              return true;
            }

            if(!this.shared)
            {
              return true;
            }

            return this.reviewee.name.value === "" &&
                this.reviewee.email.value === "" &&
                this.reviewee.number.value === "" &&
                this.reviewee.expiry.value === "";
          }
        },
        mounted: function ()
        {
          this.refreshState();
        },
         watch: {
          'form.reviewee': {
            handler() {
              this.refreshState();
            },
            deep: true
          }
        },
        methods:
          {
            show()
            {
              if(this.entryId)
              {
                this.refreshState();
                this.$refs.modal.show();
              }
            },
            close()
            {
                this.$refs.modal.hide();
            },
            refreshState() {
              if(!this.form.reviewee)
              {
                this.form.reviewee =
                {
                  ExpiresAt: "",
                  RevieweeEmail: "",
                  RevieweeName: "",
                  RevieweeNumber: "",
                  RevieweeType: "",
                  shared:false,
                  Id:null
                };
              }
              else
              {
                this.reviewee.type.value = this.form.reviewee.RevieweeType;

                this.reviewee.name.value = this.form.reviewee.RevieweeName;
                this.reviewee.name.title = this.reviewee.type.value+" Name";
                this.reviewee.name.disabled = true;

                this.reviewee.email.value = this.form.reviewee.RevieweeEmail;
                this.reviewee.email.title = this.reviewee.type.value+" Email";
                this.reviewee.email.disabled = true;

                this.reviewee.number.value = this.form.reviewee.RevieweeNumber;
                this.reviewee.number.title = this.reviewee.type.value+" number";
                this.reviewee.number.disabled = true;

                if (this.reviewee.expiry.values.find(value => value === this.form.reviewee.ExpiresAt) === undefined)
                {
                  this.reviewee.expiry.values.push(this.form.reviewee.ExpiresAt);
                }
                this.reviewee.expiry.value = this.form.reviewee.ExpiresAt;
                
                if(this.form.reviewee.ExpiresAt) {
                  this.shared = true;

                  this.reviewee.expiry.title = "Expires At";
                  this.reviewee.expiry.disabled = true;
                } else {
                  this.shared = false;
                  this.reviewee.expiry.disabled = false;
                }

              }
            },
            reset(event)
            {
              event.preventDefault();
              this.loading = true;

              this.$api.v2.post(`supervision/reset`,
        {
                entryId:this.entryId
              },
      {
                headers:
                {
                  'Content-Type': 'application/json'
                }
              }
              ).then((resp) =>
              {
                this.$success('Reset Successfully', resp.body.message);

                this.form.reviewee.ExpiresAt = "";
                this.reviewee.expiry.value = "";
                this.reviewee.expiry.values = ["1","7","14","30"];
                this.reviewee.expiry.disabled = false;

              }).catch((resp) =>
              {
                this.$httpError('Failed to Reset', resp);
              }).then(() =>
              {
                this.loading = false;
                this.shared = false;
                this.close();
              });
            },
            share(event)
            {
              event.preventDefault();

              this.loading = true;
              let topics = this.form.pages.filter(page => page.repeater === true)[0].subPages;

              this.$api.v2.post(`supervision/share`,
        {
                entryId:this.entryId,
                reviewee:
                {
                  type:this.reviewee.type.value,
                  name:this.reviewee.name.value,
                  email:this.reviewee.email.value,
                  number:this.reviewee.number.value,
                  expiry:this.reviewee.expiry.value
                },
                topics:topics
              },
      {
                headers:
                {
                  'Content-Type': 'application/json'
                }
              }
              ).then((resp) =>
              {
                this.$success('Shared Successfully', resp.body.message);
                this.shared = true;
              }).catch((resp) =>
              {
                this.$httpError('Failed to share', resp);
              }).then(() =>
              {
                this.loading = false;
                this.close();
                this.$router.push('/entries');
              });
            }
        }
    }
</script>
